export const iocNames = {
  window: Symbol.for('window'),
  document: Symbol.for('document'),
  localStorage: Symbol.for('localStorage'),
  crypto: Symbol.for('crypto'),
  location: Symbol.for('location'),
  cookies: Symbol.for('cookies'),
  navigator: Symbol.for('navigator'),
  appConfig: Symbol.for('appConfig'),
  logger: Symbol.for('logger'),
  getLogger: Symbol.for('getLogger'),
  dateService: Symbol.for('dateService'),
  sessionService: Symbol.for('sessionService'),
  authStore: Symbol.for('authStore'),
  navigationService: Symbol.for('navigationService'),
  authModalService: Symbol.for('authModalService'),
  gaIdProvider: Symbol.for('gaIdProvider'),
  utIdProvider: Symbol.for('utIdProvider'),
  dizraptorApi: Symbol.for('utexApi'),
  visitCollector: Symbol.for('visitCollector'),
  isUserAuthorized: Symbol.for('isUserAuthorized'),
  featureFlagsStore: Symbol.for('featureFlagsStore'),
  userInfoStore: Symbol.for('userInfoStore'),
  currentLang: Symbol.for('currentLang'),
  zendeskWidget: Symbol.for('zendeskWidget'),
  podsightsApi: Symbol.for('podsightsApi'),
  history: Symbol.for('history'),
  gqlService: Symbol.for('gqlService'),
  userCardsStore: Symbol.for('userCardsStore'),
  ideasStore: Symbol.for('ideasStore'),
  kycStatus: Symbol.for('kycStatus'),
  entityCache: Symbol.for('entityCache'),
  sumsubData: Symbol.for('sumsubData'),
  stepsModalServiceFactory: Symbol.for('stepsModalServiceFactory'),
  eventBus: Symbol.for('eventBus')
};
